import { useAtomValue } from 'jotai';

import { isPendingProjectListingStageAtom } from '@/state/project-listing-pending-stage.state';

export const useIsPendingProjectListingStageMutation = (
  listingId: string,
): boolean => useAtomValue(isPendingProjectListingStageAtom(listingId));
